module.exports = __webpack_public_path__ + "img/Nicole+Jon-45.b5518c57.jpg";